<template>
  <div class="campusBox">
    <!-- 背景是图片 -->
    <div class="tnavListBox">
      <div class="tnavList">
        <router-link v-for="(items,index) in campusData" :to="{name:'CampusCon',query:{id:items.id,cityId:items.dic_code}}" class="tnavListLi" @click.native="refresh" :key="index">{{items.dic_name}}</router-link>
      </div>
      <!-- <top-shadow class="topShadow"></top-shadow> -->
    </div>
    <router-view v-if="isRouterAlive"/>  
  </div>
</template>
<script>
import '../../../static/js/swiper.min.js'
export default {
  name: 'Home',
  data () {
    return {
      campusData: '',
      isRouterAlive: true,
      topNavLen:0,
    }
  },
  created(){
    this.axios.get(this.$root.baseUrl+'/wap/home/city')
    .then(res=>{
      this.topNavLen = res.data.length;
      this.campusData = res.data;
    })
    .catch(e=>{
      console.log(e)
    })
  },
  methods: {
    refresh:function(){
      // console.log(this.$route.query.id)
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true))
    }
  },
  mounted() {
        var this_ = this;
        window.onload=function(){
          document.getElementsByClassName("tnavList")[0].style.width = this_.topNavLen*9+'rem'
        }  
  }
}

</script>
<style scoped>
  
.campusBox{
  width: 100%;
  /*height: 100%;*/
  margin: 3.2rem auto 0;
  display: inline-block;
} 
a{
  color: #333;
}
.tnavListBox{
  overflow: hidden;
  width: 100%;
  overflow-x: scroll;
  position: fixed;
  top: 3.2rem;
  background: #fff;
  height: 2.25rem;
  line-height: 1.6rem;
  box-shadow: 0 0 18px rgba(42, 42, 42, 0.1);  
  width: 100%;
  z-index: 9;  
}
.tnavList{
  height: 1.6rem;
  line-height: 1.6rem;
  width: 29rem;
}
.tnavListBox::-webkit-scrollbar {/*滚动条整体样式*/
    width: 0.1rem;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 0.1rem;
}
.tnavListLi{
  padding: 0.6rem 0;
  font-size: 0.9333rem;
  margin: 0 1.5rem;
}
a{
  color: #808080;
}
.router-link-exact-active{
    color: #333;
    border-bottom: 2px solid #ff7800;
}
</style>


// WEBPACK FOOTER //
// src/components/campus/Campus.vue